module.exports = __webpack_public_path__ + "files/5567e26caac86ba81f2701afca71ef11.png";